export default class PeriodService {
    static getPeriod(period: string): string {
        if(period.toLowerCase() === "noon") {
            return "Midi";
        }
        return "Soir";
    }
}